<template>
    <button v-if="hasAccess" class="btn btn-light btn-sm" type="button" @click="onClick">
        View variables
    </button>
</template>

<script>
export default {
    name: "TableCellProductOptionsButtons",
    props: {
        item: Object,
    },
    computed: {
        hasAccess() {
            return !!this.$store.getters['user/access']('product_variables')
        }
    },
    methods: {
        onClick() {
            window.location = '/#/product_variables?optionId=' + this.item.id
        }
    }
}
</script>

<style scoped>

</style>